import {useState, useEffect} from 'react';
import { getWordMetadataList } from '../../../../../services/WordMetadataService';
import * as Sentry from '@sentry/browser';
import { logSentryException } from '../../../../../services/util';

export default function useBlendingActivityWordMetadata({phrase, phraseMetadata, exampleWord}) {

  // split the phrase into the words and the graphemes
  const splitPhrase = phrase.split(" ");
  const graphemes = splitPhrase.slice(0, -1); // assume everything except for the last "word" of the phrase is the graphemic breakdown
  const word = splitPhrase[splitPhrase.length - 1];

  const [wordMetadata, setWordMetadata] = useState(null);
  const [exampleWordMetadata, setExampleWordMetadata] = useState(null);

  const [error, setError] = useState(null);

  useEffect(() => {
    
    // If phraseMetadata is null, clear wordMetadata to force loading state
    if (!phraseMetadata) {
      setWordMetadata(null);
      return;
    }
    
    if(word && phraseMetadata){
      const metadataIndex = splitPhrase.length - 1;
      const meta = phraseMetadata[metadataIndex];
      
      try {
        if (!meta) {
          throw new Error(`No valid word metadata in props for word "${word}" in phrase "${phrase}"`);
        }

        const newWordMetadata = meta;
        if(graphemes && graphemes.length > 0){
          newWordMetadata.GRAPHEMIC_BREAKDOWN = graphemes.join("/");
        }
        
        setWordMetadata(newWordMetadata);
      } catch (err) {
        console.error("useBlendingActivityWordMetadata error", err)
        setError(err)
        logSentryException(new Error('Blending activity word metadata missing'), 'Blending activity story missing word metadata', { originalError: err?.message, originalStack: err?.stack });
      }
    }
  }, [phrase, phraseMetadata]);

  useEffect(() => {
    if(exampleWord){
      getWordMetadataList([exampleWord])
        .then((words) => {
          if (words.length) {
            const newExampleWordMetadata = words[0];
            setExampleWordMetadata(newExampleWordMetadata);
          } else {
            throw new Error(`GetWordMetadataList returned empty list for ${exampleWord}`);
          }
        }).catch((err) => {
          console.error("Blending activity story missing example word metadata", err)
          setError(err)
          logSentryException(new Error('Blending activity example word metadata missing'), 'Blending activity story missing example word metadata', { originalError: err?.message, originalStack: err?.stack });
        })
    }
  }, [exampleWord]);

  const loading = (!wordMetadata || (exampleWord && !exampleWordMetadata) || !phraseMetadata) && !error;

  return {
    wordMetadata,
    exampleWordMetadata,
    word,
    error,
    loading,
  }
}